import { themeColors } from '../../../themeColors';
/**
 * @file   src\mobile\components\clientManagement\ViewClientMenu.js
 * @brief  This file is responsible for view client menu in dashboard section
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";

const ViewClientMenu = (props) => {
  const { wantAdCount, inventoryCount, favoriteCount, clientId, clientName } =
    props;
  const navigate = useNavigate();

  return (
    <div className="menu-wrap bg-white">
      <div
        className="menu-block d-flex justify-content-between align-items-center"
        onClick={() =>
          navigate(pageURLs.mobileClientNoteListing, {
            state: { clientId: clientId },
          })
        }
        role="button"
        onKeyDown={() =>
          navigate(pageURLs.mobileClientNoteListing, {
            state: { clientId: clientId },
          })
        }
      >
        <div className="menu-label d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H14.6897C14.8867 21.0003 15.0818 20.9616 15.2638 20.8862C15.4458 20.8107 15.611 20.7 15.75 20.5603L20.5603 15.75C20.7 15.611 20.8107 15.4458 20.8862 15.2638C20.9616 15.0818 21.0003 14.8867 21 14.6897V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM9 8.25H15C15.1989 8.25 15.3897 8.32902 15.5303 8.46967C15.671 8.61032 15.75 8.80109 15.75 9C15.75 9.19891 15.671 9.38968 15.5303 9.53033C15.3897 9.67098 15.1989 9.75 15 9.75H9C8.80109 9.75 8.61032 9.67098 8.46967 9.53033C8.32902 9.38968 8.25 9.19891 8.25 9C8.25 8.80109 8.32902 8.61032 8.46967 8.46967C8.61032 8.32902 8.80109 8.25 9 8.25ZM12 15.75H9C8.80109 15.75 8.61032 15.671 8.46967 15.5303C8.32902 15.3897 8.25 15.1989 8.25 15C8.25 14.8011 8.32902 14.6103 8.46967 14.4697C8.61032 14.329 8.80109 14.25 9 14.25H12C12.1989 14.25 12.3897 14.329 12.5303 14.4697C12.671 14.6103 12.75 14.8011 12.75 15C12.75 15.1989 12.671 15.3897 12.5303 15.5303C12.3897 15.671 12.1989 15.75 12 15.75ZM9 12.75C8.80109 12.75 8.61032 12.671 8.46967 12.5303C8.32902 12.3897 8.25 12.1989 8.25 12C8.25 11.8011 8.32902 11.6103 8.46967 11.4697C8.61032 11.329 8.80109 11.25 9 11.25H15C15.1989 11.25 15.3897 11.329 15.5303 11.4697C15.671 11.6103 15.75 11.8011 15.75 12C15.75 12.1989 15.671 12.3897 15.5303 12.5303C15.3897 12.671 15.1989 12.75 15 12.75H9ZM15 19.1897V15H19.1906L15 19.1897Z"
              fill={themeColors.secondary200}
            />
          </svg>
          <p>Client Notes</p>
        </div>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.46967 3.96967C8.76256 3.67678 9.23744 3.67678 9.53033 3.96967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.53033 20.0303C9.23744 20.3232 8.76256 20.3232 8.46967 20.0303C8.17678 19.7374 8.17678 19.2626 8.46967 18.9697L15.4393 12L8.46967 5.03033C8.17678 4.73744 8.17678 4.26256 8.46967 3.96967Z"
              fill={themeColors.neutral890}
            />
          </svg>
        </span>
      </div>
      <div
        className="menu-block d-flex justify-content-between align-items-center"
        onClick={() =>
          navigate(pageURLs.mobileClientWantAd, {
            state: { clientId: clientId },
          })
        }
        role="button"
        onKeyDown={() =>
          navigate(pageURLs.mobileClientWantAd, {
            state: { clientId: clientId },
          })
        }
      >
        <div className="menu-label d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M6.61538 9.26101H9.69231V13.9568H6.61538V9.26101ZM22 4.56525V20.2178C21.9999 20.3512 21.9664 20.4823 21.9025 20.5988C21.8386 20.7153 21.7465 20.8132 21.6349 20.8833C21.5233 20.9534 21.396 20.9933 21.2651 20.9992C21.1341 21.0052 21.0038 20.977 20.8865 20.9173L18.1538 19.5271L15.4212 20.9173C15.3143 20.9717 15.1964 21 15.0769 21C14.9574 21 14.8396 20.9717 14.7327 20.9173L12 19.5271L9.26731 20.9173C9.16044 20.9717 9.04258 21 8.92308 21C8.80357 21 8.68572 20.9717 8.57885 20.9173L5.84615 19.5271L3.11346 20.9173C2.99622 20.977 2.86592 21.0052 2.73494 20.9992C2.60397 20.9933 2.47666 20.9534 2.3651 20.8833C2.25355 20.8132 2.16145 20.7153 2.09755 20.5988C2.03365 20.4823 2.00007 20.3512 2 20.2178V4.56525C2 4.15012 2.16209 3.75199 2.4506 3.45845C2.73912 3.16491 3.13044 3 3.53846 3H20.4615C20.8696 3 21.2609 3.16491 21.5494 3.45845C21.8379 3.75199 22 4.15012 22 4.56525ZM11.2308 8.47839C11.2308 8.27082 11.1497 8.07176 11.0055 7.92499C10.8612 7.77822 10.6656 7.69576 10.4615 7.69576H5.84615C5.64214 7.69576 5.44648 7.77822 5.30223 7.92499C5.15797 8.07176 5.07692 8.27082 5.07692 8.47839V14.7394C5.07692 14.947 5.15797 15.146 5.30223 15.2928C5.44648 15.4396 5.64214 15.522 5.84615 15.522H10.4615C10.6656 15.522 10.8612 15.4396 11.0055 15.2928C11.1497 15.146 11.2308 14.947 11.2308 14.7394V8.47839ZM18.9231 13.1741C18.9231 12.9666 18.842 12.7675 18.6978 12.6207C18.5535 12.474 18.3579 12.3915 18.1538 12.3915H13.5385C13.3344 12.3915 13.1388 12.474 12.9945 12.6207C12.8503 12.7675 12.7692 12.9666 12.7692 13.1741C12.7692 13.3817 12.8503 13.5808 12.9945 13.7276C13.1388 13.8743 13.3344 13.9568 13.5385 13.9568H18.1538C18.3579 13.9568 18.5535 13.8743 18.6978 13.7276C18.842 13.5808 18.9231 13.3817 18.9231 13.1741ZM18.9231 10.0436C18.9231 9.83608 18.842 9.63701 18.6978 9.49024C18.5535 9.34347 18.3579 9.26101 18.1538 9.26101H13.5385C13.3344 9.26101 13.1388 9.34347 12.9945 9.49024C12.8503 9.63701 12.7692 9.83608 12.7692 10.0436C12.7692 10.2512 12.8503 10.4503 12.9945 10.597C13.1388 10.7438 13.3344 10.8263 13.5385 10.8263H18.1538C18.3579 10.8263 18.5535 10.7438 18.6978 10.597C18.842 10.4503 18.9231 10.2512 18.9231 10.0436Z"
              fill={themeColors.accentf500}
            />
          </svg>
          <p>
            Want-Listings <span>({wantAdCount})</span>
          </p>
        </div>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.46967 3.96967C8.76256 3.67678 9.23744 3.67678 9.53033 3.96967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.53033 20.0303C9.23744 20.3232 8.76256 20.3232 8.46967 20.0303C8.17678 19.7374 8.17678 19.2626 8.46967 18.9697L15.4393 12L8.46967 5.03033C8.17678 4.73744 8.17678 4.26256 8.46967 3.96967Z"
              fill={themeColors.neutral890}
            />
          </svg>
        </span>
      </div>
      <div
        className="menu-block d-flex justify-content-between align-items-center"
        onClick={() =>
          navigate(pageURLs.mobileClientInventory, {
            state: { clientId: clientId },
          })
        }
        role="button"
        onKeyDown={() =>
          navigate(pageURLs.mobileClientInventory, {
            state: { clientId: clientId },
          })
        }
      >
        <div className="menu-label d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M19.571 7.751L19.5 7.695V3.75C19.5 3.336 19.164 3 18.75 3H16.75C16.336 3 16 3.336 16 3.75V4.9375L13.6235 3.065C12.6675 2.3115 11.332 2.3115 10.3765 3.065L4.429 7.751C3.521 8.4665 3 9.54 3 10.6965V19.741C3 20.706 3.785 21.491 4.75 21.491H19.25C20.215 21.491 21 20.706 21 19.741V10.6965C21 9.54 20.479 8.4665 19.571 7.751ZM10 16C10 16.276 9.776 16.5 9.5 16.5H7.5C7.224 16.5 7 16.276 7 16V13C7 12.724 7.224 12.5 7.5 12.5H9.5C9.776 12.5 10 12.724 10 13V16ZM17 16C17 16.276 16.776 16.5 16.5 16.5H14.5C14.224 16.5 14 16.276 14 16V13C14 12.724 14.224 12.5 14.5 12.5H16.5C16.776 12.5 17 12.724 17 13V16Z"
              fill={themeColors.primary500}
            />
          </svg>
          <p>
            Inventory <span>({inventoryCount})</span>
          </p>
        </div>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.46967 3.96967C8.76256 3.67678 9.23744 3.67678 9.53033 3.96967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.53033 20.0303C9.23744 20.3232 8.76256 20.3232 8.46967 20.0303C8.17678 19.7374 8.17678 19.2626 8.46967 18.9697L15.4393 12L8.46967 5.03033C8.17678 4.73744 8.17678 4.26256 8.46967 3.96967Z"
              fill={themeColors.neutral890}
            />
          </svg>
        </span>
      </div>
      <div
        className="menu-block d-flex justify-content-between align-items-center"
        onClick={() =>
          navigate(pageURLs.mobileWantAdFavorites, {
            state: {
              clientName: clientName,
              clientId: clientId,
              favCount: favoriteCount,
              isFromClientDashboard: true,
            },
          })
        }
        role="button"
        onKeyDown={() =>
          navigate(pageURLs.mobileWantAdFavorites, {
            state: {
              clientName: clientName,
              clientId: clientId,
              favCount: favoriteCount,
              isFromClientDashboard: true,
            },
          })
        }
      >
        <div className="menu-label d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M16.5 3C15.6267 3 14.7655 3.20332 13.9844 3.59385C13.2034 3.98438 12.524 4.5514 12 5.25C11.2916 4.30553 10.3041 3.60787 9.17719 3.25586C8.0503 2.90385 6.84122 2.91532 5.72122 3.28866C4.60121 3.66199 3.62707 4.37826 2.93676 5.336C2.24646 6.29375 1.875 7.44441 1.875 8.625C1.875 15.3656 11.2406 20.6812 11.6344 20.9062C11.7459 20.969 11.872 21.0013 12 21C12.1281 21.0022 12.2544 20.9698 12.3656 20.9062C14.0903 19.898 15.708 18.7169 17.1937 17.3812C20.4656 14.4375 22.125 11.4937 22.125 8.625C22.125 7.13316 21.5324 5.70242 20.4775 4.64752C19.4226 3.59263 17.9918 3 16.5 3Z"
              fill="#DA4167"
            />
          </svg>
          <p>
            Favorites <span>({favoriteCount})</span>
          </p>
        </div>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.46967 3.96967C8.76256 3.67678 9.23744 3.67678 9.53033 3.96967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.53033 20.0303C9.23744 20.3232 8.76256 20.3232 8.46967 20.0303C8.17678 19.7374 8.17678 19.2626 8.46967 18.9697L15.4393 12L8.46967 5.03033C8.17678 4.73744 8.17678 4.26256 8.46967 3.96967Z"
              fill={themeColors.neutral890}
            />
          </svg>
        </span>
      </div>
    </div>
  );
};
export default ViewClientMenu;
